import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";
  
export const getAllAssignedFeeStructureToCalssMapping = async (schoolID, query) => {
 return commonFetch(`${API_URLS.GET_ALL_FEE_STRUCTURE_TO_CLASS_APIURL}/${schoolID}`, {
    method: 'POST',
    body: query,
    requiresAuth: true,
  });
};
